import { render, staticRenderFns } from "./InnCheckbox.vue?vue&type=template&id=3a9531a0"
import script from "./InnCheckbox.vue?vue&type=script&lang=js"
export * from "./InnCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports